export const _user = (state) => state.app.user;
export const _isAdmin = (state) => state.app.admin;
export const _loading = (state) => state.app.loading;
